module.exports = {"431125100":"潇浦镇","431125101":"上江圩镇","431125103":"夏层铺镇","431125104":"桃川镇","431125105":"粗石江镇","431125200":"松柏瑶族乡","431125202":"千家峒瑶族乡","431125203":"兰溪瑶族乡","431125204":"源口瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431125.json
// module id = 1909
// module chunks = 0